import { userSelectors } from "@fitness-app/app-store";
import { UserRole } from "@fitness-app/data-models";

import { useAppSelector } from "~/store/initializeStore";

export const useUserClaims = () => {
  const { trainerId, memberRole, memberId, isRegularTrainer, isSharedTrainer, isAdministration, role } = useAppSelector(
    userSelectors.getUserClaims,
  );

  return {
    trainerId,
    memberRole,
    memberId,
    isRegularTrainer,
    isSharedTrainer,
    isAdministration,
    isOwner: role === UserRole.TRAINER,
  };
};
